'use client';
import { Button } from '@okee-uikit/react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ClickEvent } from '#/components/event-tracker/client';
import { BASE_PATH, LOGIN_PAGE } from '#/utils/const';

export function LoginButton() {
  const t = useTranslations();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currUrl = new URL(`${BASE_PATH}${pathname}`);
  currUrl.search = searchParams?.toString() || '';

  return (
    <ClickEvent eventName='home_page_login' useBeacon>
      <a href={`${LOGIN_PAGE}?redirect=${encodeURIComponent(currUrl.href)}`}>
        <Button colorScheme='primary' shape='round' size='xs' variant={['fill']}>
          {t('log_in')}
        </Button>
      </a>
    </ClickEvent>
  );
}
